/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

export const List = (props) => {
  let listItems = props.items.map((item, index) => (
    props.border
      ? <ListItem className="slds-item" key={`list_item_${props.id}-${index}`}>{item}</ListItem>
      : <ListItem key={`list_item_${props.id}-${index}`}>{item}</ListItem>
  ))

  let typeClass = props.type === "dotted"
    ? "slds-list_dotted"
    : props.type === "decimal"
      ? "slds-list_ordered"
      : ''  // default

  let dividerClass = props.border
    ? `slds-has-dividers_${props.border}-space`
    : ''

  return (
    <ul className={`${typeClass} ${dividerClass} ${props.className ? props.className : ''}`}>
      {listItems}
    </ul>
  )
}

List.defaultProps = {
  type: "default",
  id: `${Math.floor(Math.random() * 1000)}`
}

List.propTypes = {
  id: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ])).isRequired,
  type: PropTypes.oneOf([
    "default", "dotted", "decimal"
  ]).isRequired,
  border: PropTypes.oneOf(["top", "bottom", "around"]),
  className: PropTypes.string
}

export const ListItem = ({ children, className }) => (
  <li className={className ? className : ''}>
    {children}
  </li>
)

ListItem.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]).isRequired,
  className: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/list/index.js